import React from 'react'
import logo from '../../assets/J-LOGO-PINKLAV.png'
import '../../styles/home.css'

const Home = () => {
  return (
    <div className='home-container'>
      <img src={logo} alt='janette king logo' />
    </div>
  )
}

export default Home
